module.exports = __webpack_public_path__ + "img/522221_91343B_7F6F6B_744960-256px.ba4df7ce.png";